import getWindowProperty from "../browser/getWindowProperty";

const checkMediaProperty = (mediaQueryString: string): boolean => {
  const { matchMedia } = getWindowProperty();

  return (matchMedia && matchMedia(`(${mediaQueryString})`).matches) || false;
};

export default checkMediaProperty;
